import {ReactNode} from 'react';

const withPlaceholder = (field: ReactNode) => field || '-';

export default withPlaceholder;
